let l = location;
export const DOMAIN    = `${l.host}`;
const PROTOCOL         = "https://"
const POSTFIX          = "api";
const VERSION          = "v1";
const NAMESPACE        = "evportal-web";

const BASE_URL = `${l.protocol}//${DOMAIN}/evportal/${POSTFIX}`;
const BASE_WS_URL = `ws://${DOMAIN}/portal`;
const CURRENT_PROFILE = window.gconf.profile;

export default {
  NAMESPACE,
  CURRENT_PROFILE,
  api: {
    DOMAIN,
    BASE_URL,
    BASE_WS_URL
  }
}